import { StorageSubsystem } from "mcsmanager-common";
export default new StorageSubsystem();
